import { TableCell, styled } from '@mui/material';

export const TagTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'interactive',
})<{ interactive?: boolean }>(({ theme, interactive }) => ({
  ':first-of-type': { borderLeft: 0 },

  borderBottom: `1px solid ${theme.vars.palette.divider}`,
  borderLeft: `1px solid ${theme.vars.palette.divider}`,
  transition: theme.transitions.create('background-color'),
  ...(interactive && {
    '&:hover': { backgroundColor: `rgba(${theme.vars.palette.success.mainChannel} / 0.05)` },
  }),
}));
